<template>
  <f7-panel left class="panelBackground">

    <!-- DR: Icone pour enelever le close-panel (MobileLeftPanel) -->
    <div >
      <f7-link
        class="headbandTextColor"
         close-picker close-panel="left">
        <i class="fa-solid fa-xmark iconRemovePanel"></i>
      </f7-link>
    </div>

    <!-- Identity header -->
    <mobile-language-picker></mobile-language-picker>
    <mobile-identity-header :username="userName"/>

    <div class="overflow-y-auto overflow-x-hidden h-100vh">
      <!-- Profile options container -->
      <mobile-menu-container>
        <mobile-menu-section-list-item
          class="profileInformationContainer"
          labelId="leftPanelTitle.accueil"
          @click="goToLink('/home/')">
        </mobile-menu-section-list-item>
        <mobile-menu-section-list-item
          class="profileInformationContainer"
          labelId="leftPanelTitle.my_prfl"
          @click="goToLink('/profile/')">
        </mobile-menu-section-list-item>
        <mobile-menu-section-list-item
          class="profileInformationContainer"
          labelId="leftPanelTitle.swtch_prfl"
          @click="activateModalProfile">
        </mobile-menu-section-list-item>
        <mobile-menu-section-list-item
          class="profileInformationContainer"
          labelId="Webheader.settings"
          @click="goToLink('/settings/application/')">
        </mobile-menu-section-list-item>
        <mobile-menu-section-list-item
          v-if="this.accountType === '1'"
          class="profileInformationContainer"
          labelId="Webheader.company_members"
          @click="goToLink('/accountMembers/')">
        </mobile-menu-section-list-item>
        <mobile-menu-section-list-item
          class="profileInformationContainer"
          labelId="leftPanelTitle.lgout"
          @click="logoutWait">
        </mobile-menu-section-list-item>
      </mobile-menu-container>

      <hr />

      <!-- Navigation menu -->
      <mobile-menu-container>
        <!-- Section (with included header) -->
        <mobile-menu-section
          v-for="item in menu" :key="item.id"
          v-if="!isDisabledItem(item) && item.enabled"
          :headerLabelId="hasOneRight(item.list) ? item.titleShort : ''">

            <!-- if List of items -->
            <div v-if="item.list">
              <mobile-menu-section-list-item
                v-for="subItem in item.list" :key="subItem.id"
                v-if="subItem.id !== 0 && !isDisabledItem(subItem) && subItem.enabled"
                class="ml-20px"
                :labelId="subItem.titleShort"
                @click="getClicked(subItem)">
              </mobile-menu-section-list-item>
            </div>

            <!-- else if One item with link -->
            <div v-else-if="item.link">
              <mobile-menu-section-list-item
                :labelId="item.title"
                :disabled="isDisabledItem(item)"
                @click="goToLink(item.link)">
              </mobile-menu-section-list-item>
            </div>
        </mobile-menu-section>
      </mobile-menu-container>
    </div>
  </f7-panel>
</template>

<script>
import MobileLanguagePicker from '@/components/menus/MobileMenuComponents/MobileLanguagePicker'
import MobileMenuContainer from '@/components/menus/MobileMenuComponents/MobileMenuContainer'
import MobileMenuSection from '@/components/menus/MobileMenuComponents/MobileMenuSection'
import MobileMenuSectionListItem from '@/components/menus/MobileMenuComponents/MobileMenuSectionListItem'
import MobileIdentityHeader from '@/components/menus/MobileMenuComponents/MobileIdentityHeader'

import Services from '@/helpers/services'
import {reloadPage2} from './../../helpers/routing'

export default {
  name: 'MobileLeftPanel',
  components: {
    'mobile-language-picker': MobileLanguagePicker,
    'mobile-menu-container': MobileMenuContainer,
    'mobile-menu-section': MobileMenuSection,
    'mobile-menu-section-list-item': MobileMenuSectionListItem,
    'mobile-identity-header': MobileIdentityHeader
  },
  props: {
    context: {
      default: 'generic',
      type: String
    }
  },
  data () {
    return {
      currentLink: '',
      currentSubitem: {},
      windowWidth: window.innerWidth,
      menu: [],
      userName: '',
      accountType: '0'
    }
  },
  created () {
    if (this.context && this.context !== 'generic') {
      this.menuLinkList = require('./data/menu_' + this.context + '.json')
    } else {
      this.menuLinkList = require('./data/menu.json')
    }
    this.menu = this.menuLinkList['linkContent']
    this.userName = this.$engine.user.get().name
    this.accountType = this.$engine.user.get().type
    // window.addEventListener('resize', this.handleResize)

    this.$bus.$on('refresh-cache-menu', () => {
      this.userName = this.$engine.user.get().name
      this.accountType = this.$engine.user.get().type
    })
  },
  methods: {
    handleResize () {
      let that = this
      that.windowWidth = window.innerWidth
      that.$engine.services.directPayments.filter.smartphoneStorage = !that.isLaptop
      that.$bus.emit('window-resize')
    },
    hasOneRight (itemList) {
      let that = this
      if(itemList !== undefined) {
        return itemList.filter(item => {
          return !that.isDisabledItem(item)
        }).length
      } else {
        return false
      }
      
    },
    getClicked (subitem) {
      if (!subitem.link) {
        return
      }
      this.currentSubitem = subitem
      this.Dom7('.panel-left').on('panel:closed', this.loadPageFromRoute)
    },
    goToLink (linkToGo) {
      this.currentLink = linkToGo
      this.Dom7('.panel-left').on('panel:closed', this.loadPageFromLink)
    },
    logout () {
      this.Dom7('.panel-left').off('panel:closed')
      this.$bus.emit('logout')
    },
    logoutWait () {
      this.Dom7('.panel-left').on('panel:closed', this.logout)
    },
    loadPageFromLink () {
      let that = this
      this.Dom7('.panel-left').off('panel:closed')
      reloadPage2(that, this.currentLink)
    },
    loadPageFromRoute () {
      this.Dom7('.panel-left').off('panel:closed')
      let subitem = this.currentSubitem
      let that = this
      reloadPage2(that, subitem.link)
    },
    activateModalProfile () {
      this.$f7.popup('#switch-profile-true')
    },
    isDisabledItem (item) {
      if (item && item.right_disable && item.right_disable.right) { // If item has a right value
        // Return true if the right has the same state as the disabling state
        return this.$engine.rights.rightIs(item.right_disable.right, item.right_disable.state)
      }
      return false
    }
  },
  computed: {
    isLaptop () {
      return this.windowWidth >= 1024
    }
  }
}
</script>
